"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prism_icons_1 = require("@octanner/prism-icons");
var styles_1 = require("./styles");
function StepIcon(props) {
    var active = props.active, completed = props.completed, className = props.className, icon = props.icon;
    if (completed) {
        return (react_1.default.createElement(styles_1.StepIconRoot, { ownerState: { active: active, completed: completed }, className: className },
            react_1.default.createElement("div", { className: "StepIcon-completedIcon" },
                react_1.default.createElement(prism_icons_1.Check, { className: "checkIcon" }),
                react_1.default.createElement(prism_icons_1.CheckResponsive, { className: "checkResponsiveIcon" }),
                react_1.default.createElement(prism_icons_1.Pencil, { className: "pencilIcon" }))));
    }
    return (react_1.default.createElement(styles_1.StepIconRoot, { ownerState: { active: active, completed: completed }, className: className },
        react_1.default.createElement(styles_1.IconWrapper, null, icon)));
}
exports.default = StepIcon;
//# sourceMappingURL=index.js.map